var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 169.879,
    height: 73.127,
    viewBox: "0 0 169.879 73.127",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_345",
    "data-name": "Rectangle 345",
    width: 169.879,
    height: 73.127,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo1",
    transform: "translate(0 51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518",
    transform: "translate(0 -51)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_712",
    "data-name": "Path 712",
    d: "M628.549,4.167A4.167,4.167,0,1,1,624.381,0a4.167,4.167,0,0,1,4.167,4.167",
    transform: "translate(-458.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_713",
    "data-name": "Path 713",
    d: "M285.668,73.9l-.841-.171c-3.949-.819-5.122-3.058-3.728-6.87,1.363-3.727,3.95-5.87,7.889-6.192a29.724,29.724,0,0,1,6.345.005c3.877.524,6.053,3.012,6.016,6.935a29.366,29.366,0,0,1-.947,6.929c-2.113,8.259-6.231,15.235-13.576,19.941a24.034,24.034,0,0,1-17.59,3.458c-7.278-1.26-11.593-6.706-11.7-14.545a47.18,47.18,0,0,1,2.219-13.567A88.633,88.633,0,0,1,270.092,45.9c5.753-8.952,14.139-12.374,24.494-11.639a20.37,20.37,0,0,1,8.741,2.282,8.8,8.8,0,0,1,4.917,8.015c0,3.823-.758,7.5-3.671,10.245a10.053,10.053,0,0,1-10.291,2.279c-2.481-.733-3.395-2.55-2.79-5.064.193-.8.482-1.578.662-2.38.385-1.714-.15-2.431-1.915-2.61a5.73,5.73,0,0,0-5.427,2.206,33.8,33.8,0,0,0-3.491,5.754,106.49,106.49,0,0,0-7.507,20.906,19.26,19.26,0,0,0-.478,4.762A2.732,2.732,0,0,0,276.42,83.6a8.277,8.277,0,0,0,3.8-1.037c3.162-1.922,4.526-5.089,5.453-8.665",
    transform: "translate(-190.457 -25.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_714",
    "data-name": "Path 714",
    d: "M464.178,34.23c1.467.134,2.945.2,4.4.415,6.96,1.049,10.944,5.417,11.433,12.425a43.051,43.051,0,0,1-1.345,12.639,89.591,89.591,0,0,1-10.637,26.875c-3.521,5.783-8.3,10.019-15.2,11.271a25.58,25.58,0,0,1-11.234-.285c-6.046-1.6-9.363-5.795-9.588-12.047a45.421,45.421,0,0,1,1.577-12.62,115.691,115.691,0,0,1,9.392-25.465c2.486-4.8,5.845-8.818,10.929-11.109a26.336,26.336,0,0,1,10.276-2.1M447.342,79.525c-.055,3.572,1.692,4.941,4.175,4.124a5,5,0,0,0,2.121-1.4,13.264,13.264,0,0,0,1.974-3.038,154.931,154.931,0,0,0,8.21-22.056,50.045,50.045,0,0,0,1.417-6.209c.441-2.784-.9-3.992-3.686-3.569-2.122.322-3.146,1.9-3.993,3.585A139.784,139.784,0,0,0,449.067,72.9c-.762,2.479-1.313,5.023-1.725,6.625",
    transform: "translate(-319.467 -25.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_715",
    "data-name": "Path 715",
    d: "M142.325,56.951c2.208,0,4.159-.109,6.091.036a16.505,16.505,0,0,1,4.3.876,3.974,3.974,0,0,1,2.645,4.324,9.69,9.69,0,0,1-8.747,9.331,56.707,56.707,0,0,1-8.288-.265c-.665-.039-1.063-.008-1.258.7-.762,2.753-1.551,5.5-2.394,8.477.547-.108.9-.167,1.248-.248,3.748-.869,7.522-1.412,11.341-.548,3.657.828,5.247,3.094,4.9,6.811a9.207,9.207,0,0,1-3.8,7c-6.8,4.73-14.181,5.737-21.826,2.438-4.9-2.114-7.178-6.277-7.194-11.561a54.761,54.761,0,0,1,2.624-15.476,112.277,112.277,0,0,1,9.563-23.449c2.233-4,4.882-7.7,9.2-9.807a24.915,24.915,0,0,1,10.621-2.206c2.369-.045,4.746.257,7.117.435a4.681,4.681,0,0,1,1.254.336c2.666,1,5.088,2.347,5.358,5.546a7.9,7.9,0,0,1-4.017,7.9c-2.739,1.651-5.807,1.945-8.906,2.038-1.691.051-3.386.077-5.076.024a1.524,1.524,0,0,0-1.648.928c-1.02,2.141-2.077,4.265-3.106,6.365",
    transform: "translate(-88.254 -24.682)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M17.041,81.636a39.775,39.775,0,0,1,4.822-.229,16.161,16.161,0,0,1,4.541.909,4.257,4.257,0,0,1,2.686,4.72A11.571,11.571,0,0,1,21.378,97.4,23.23,23.23,0,0,1,7.069,98.409C2.4,97.252-.063,93.906,0,89.082a45.786,45.786,0,0,1,2.452-12.87A166.294,166.294,0,0,1,17.2,41.984c2.74-4.752,6.807-7.022,12.348-6.4,2.84.319,4.385,1.995,4.388,4.844a24.425,24.425,0,0,1-2.553,9.891c-4.081,9.2-8.342,18.31-12.536,27.455-.574,1.252-1.164,2.5-1.8,3.862",
    transform: "translate(0 -26.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M632.442,12.866V9.3h1.279c.619,0,1.118.3,1.118,1a.958.958,0,0,1-.871.942h-.005l1.012,1.626h-.6l-.907-1.571h-.539v1.571Zm.483-1.994h.655c.5,0,.745-.181.745-.574s-.252-.574-.745-.574h-.655Z",
    transform: "translate(-467.713 -6.878)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient1);
export default __webpack_public_path__ + "static/media/client1.095aa3dd66168498a000903fe0e795e7.svg";
export { ForwardRef as ReactComponent };